// extracted by mini-css-extract-plugin
export default {"circle":"styles_circle__+KjOi","margin":"styles_margin__OxyEk","noMargin":"styles_noMargin__a2vv4"};